import {
  Box,
  Button,
  Chip,
  Pagination,
  PaginationItem,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { IoIosHeart, IoIosHeartEmpty } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css"; // Don't forget this import for styles
import {
  formatNumberWithSuffix,
  showSuccessToast,
} from "../../utils/functions";
import ProfileImg from "../Assets/Img/Imgs.png";
import newNoFavorite from "../Assets/Img/newNoFavorite.svg";
import searchResult from "../Assets/Img/searchResult.svg";
import { default as Sort, default as SortDown } from "../Assets/Img/sort.png";
import "../Assets/css/brand.css";
import InfluencerGridList from "../Common/InfluencerGridList";
import axiosMain from "./../http/axiosMain";
import filter from "../Assets/Img/filter btn collab-req.png";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { theme } from "../Common/SetupProfile/constant";
import { SearchBar } from "../Common/Components/SearchBar";
import { GlobalContext } from "../../utils/GlobalContext";
import AddInfluencerDialog from "./AddInfluencerModal";
function BrandHome({ show }) {
  const [originalInfluencers, setOriginalInfluencers] = useState([]);
  const [allInfluencers, setAllInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userData } = useContext(GlobalContext);
  const [viewed, setViewed] = useState(0);
  const [allowed, setallowed] = useState(0);
  const [planType, setPlanType] = useState("");
  const [categories, setCategories] = useState([]); // Fetched from API
  const fetchCategories = async () => {
    try {
      const response = await axiosMain.get("/api/v1/get-categories");
      const fetchedCategories = response.data.categoriesarry.map((cat) => ({
        id: cat.id,
        category: cat.name,
      }));
      setCategories(fetchedCategories);
      setFilterOptions((prev) => ({
        ...prev,
        menu4: {
          label: "Category",
          options: response.data.categoriesarry.map((cat) => ({
            value: cat.id,
            label: cat.name,
          })),
        },
      }));
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
      setFilterOptions((prev) => ({
        ...prev,
        menu4: {
          label: "Category",
          options: [],
        },
      }));
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const [open, setOpen] = useState(false); //for filter sidebar
  const [activeFilterTab, setActiveFilterTab] = useState("category");
  const [searchTerm, setSearchTerm] = useState("");
  const [openSearch, setOpenSearch] = useState(false);
  const inputRef = useRef(null);
  const [isLoding, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState();
  const [selectedFilters, setSelectedFilters] = useState({});
  // Add influencers
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPages, setRecordsPerPages] = useState(10); // Set default records per page
  const [influencers, setInfluencers] = useState([]);
  const [isFavoritesFiltered, setIsFavoritesFiltered] = useState(false);
  const [isClientPagination, setIsClientPagination] = useState(false);
  useEffect(() => {
    fetchInfluencers();
  }, [currentPage, recordsPerPages]);
  const navigate = useNavigate();
  const toggleFavorite = async (id) => {
    try {
      const influencer = influencers.find((inf) => inf.user_id === id);
      if (!influencer) return;
      const isFavorite = influencer.flag_favorite;
      const influencerName = [influencer?.first_name, influencer?.last_name]
        .filter(Boolean)
        .join(" ");
      const resp = await axiosMain.post("/api/v1/liked-influencer", {
        influencer_id: id,
      });
      if (resp.status === 200) {
        console.log(`API Updated: ${influencer.first_name}`);
      }
      const toastMessage = isFavorite
        ? `${influencerName} removed from favourites!`
        : `${influencerName} added to favourites!`;
      showSuccessToast(toastMessage);
      setInfluencers((prev) =>
        prev.map((i) => {
          return {
            ...i,
            flag_favorite:
              i.user_id === id ? !i.flag_favorite : i.flag_favorite,
          };
        })
      );
    } catch (err) {
      console.error("Error updating favorite:", err);
    }
  };
  const [isFilterPopupOpen, setIsFilterPopupOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("home");
  const [selectedEngagementFilters, setSelectedEngagementFilters] = useState(
    new Set()
  );
  const [sortDirectionEngagement, setSortDirectionEngagement] = useState("asc");
  const [sortDirectionFollowers, setSortDirectionFollowers] = useState("asc");
  const toggleFilterPopup = () => {
    setIsFilterPopupOpen(!isFilterPopupOpen);
  };
  const handleClearFilters = () => {
    setSelectedEngagementFilters(new Set());
    setFilteredData(influencers); // Reset data
  };
  useEffect(() => {
    const fetchData = async () => {
      fetchInfluencers();
    };
  }, [searchTerm]);
  const [grideView, setgrideView] = useState(() => {
    const savedView = localStorage.getItem("viewMode");
    return savedView ? JSON.parse(savedView) : false;
  });
  const toggleView = () => {
    setgrideView((prev) => {
      const newView = !prev;
      // Save the new view state to localStorage
      localStorage.setItem("viewMode", JSON.stringify(newView));
      return newView;
    });
  };
  const parseRange = (rangeStr) => {
    rangeStr = rangeStr.replace(/k/g, "000").replace(/M/g, "000000");
    let minStr, maxStr;
    if (rangeStr.includes(" - ")) {
      [minStr, maxStr] = rangeStr.split(" - ").map(s => s.trim());
    } else if (rangeStr.includes("-")) {
      [minStr, maxStr] = rangeStr.split("-").map(s => s.trim());
    } else {
      minStr = rangeStr;
      maxStr = null;
    }
    let min = parseFloat(minStr.replace("+", ""));
    let max = maxStr ? parseFloat(maxStr.replace("+", "")) : Infinity;
    return { min, max };
  };
  const applyLocalFilters = (data) => {
    let filtered = [...data];
    const localCategories = ["menu1", "menu2", "menu5", "menu6"];
    Object.keys(selectedFilters).forEach((category) => {
      if (!localCategories.includes(category)) return;
      const selectedValues = selectedFilters[category];
      if (selectedValues?.length === 0) return;
      if (category === "menu1") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const { min, max } = parseRange(range);
            return inf.reach >= min && (max === Infinity ? true : inf.reach <= max);
          })
        );
      }
      if (category === "menu2") {
        filtered = filtered.filter((inf) =>
          selectedValues.includes(inf.language)
        );
      }
      if (category === "menu5") {
        filtered = filtered.filter((inf) =>
          selectedValues.some((range) => {
            const [min, max] = range.split("-").map(Number);
            return inf.age >= min && inf.age <= max;
          })
        );
      }
      if (category === "menu6") {
        filtered = filtered.filter((inf) => selectedValues.includes(inf.city));
      }
    });
    return filtered;
  };
  const handleSortEngagement = () => {
    setInfluencers((prevData) => {
      const sortedData = [...prevData].sort((a, b) => {
        const engagementA = parseFloat(a.engagement);
        const engagementB = parseFloat(b.engagement);
        if (isNaN(engagementA) && isNaN(engagementB)) {
          return 0; // Both are NaN, no change in their order
        }
        if (isNaN(engagementA)) {
          return sortDirectionEngagement === "asc" ? 1 : -1;
        }
        if (isNaN(engagementB)) {
          return sortDirectionEngagement === "asc" ? -1 : 1;
        }
        return sortDirectionEngagement === "asc"
          ? engagementA - engagementB
          : engagementB - engagementA;
      });
      return sortedData;
    });
    setSortDirectionEngagement((prev) => (prev === "asc" ? "desc" : "asc"));
  };
  const handleSortFollowers = () => {
    setSortDirectionFollowers((prev) => {
      const newDirection = prev === "asc" ? "desc" : "asc";
      setInfluencers((prevData) => {
        const sortedData = [...prevData].sort((a, b) => {
          const followersA = parseFloat(a.followers);
          const followersB = parseFloat(b.followers);
          if (isNaN(followersA) && isNaN(followersB)) return 0;
          if (isNaN(followersA)) return newDirection === "asc" ? 1 : -1;
          if (isNaN(followersB)) return newDirection === "asc" ? -1 : 1;
          return newDirection === "asc"
            ? followersA - followersB
            : followersB - followersA;
        });
        return sortedData;
      });
      return newDirection;
    });
  };
  const filteredInfluencers = influencers.filter((influencer) =>
    influencer.handle_name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  // };
  const fetchInfluencers = async (
    searchTermParam = null,
    isFavoritesFilteredParam = null,
    filtersParam = null,
    fetchAll = false
  ) => {
    setLoading(true);
    setIsLoading(true);
    try {
      let url = "/api/influencer/influencers?";
      const search = searchTermParam ?? searchTerm;
      const isFavs = isFavoritesFilteredParam ?? isFavoritesFiltered;
      const filters = filtersParam ?? selectedFilters;
      if (search) {
        url += `search=${encodeURIComponent(search)}&`;
      }
      if (isFavs) {
        url += `onlyFavourites=true&`;
      }
      // Server-side filters
      const serverCategories = ["home", "menu3", "menu4", "menu7"];
      serverCategories.forEach((cat) => {
        if (filters[cat] && filters[cat].length > 0) {
          let paramName;
          switch (cat) {
            case "home":
              paramName = "engagementRanges";
              break;
            case "menu3":
              paramName = "followersRanges";
              break;
            case "menu4":
              paramName = "categoryIds";
              break;
            case "menu7":
              paramName = "audienceGenders";
              break;
            default:
              return;
          }
          url += `${paramName}=${encodeURIComponent(JSON.stringify(filters[cat]))}&`;
        }
      });
      if (fetchAll) {
        url += `from=0&limit=10000`;
      } else {
        const from = (currentPage - 1) * recordsPerPages;
        url += `from=${from}&limit=${recordsPerPages}`;
      }
      const response = await axiosMain.get(url);
      const countRes = await axiosMain.get(
        "/api/influencer/influencer-viewed-count"
      );
      const subData = countRes?.data?.data?.[0];
      setViewed(subData?.no_of_influencer_viewed);
      setallowed(subData?.no_of_influencer_allowed);
      setPlanType(subData?.plan_type);
      localStorage.setItem("PlanType", subData?.plan_type);
      if (fetchAll) {
        setAllInfluencers(response.data.influencers);
        setTotalCount(response.data.totalCount);
      } else {
        setInfluencers(response.data.influencers);
        setTotalCount(response.data.totalCount);
      }
      setOriginalInfluencers(response.data.influencers);
    } catch (error) {
      console.error("Error fetching influencers:", error);
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };
  const [activeTab, setActiveTab] = useState("all"); // Default active tab
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedTab(tab);
    setCurrentPage(1); // Reset to first page when switching tabs
  };
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => document.body.classList.remove("modal-open");
  }, [show]);
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const localCategories = ["menu1", "menu2", "menu5", "menu6"];
      const hasLocalFilter = localCategories.some(
        (cat) => selectedFilters[cat] && selectedFilters[cat].length > 0
      );
      fetchInfluencers(searchTerm, isFavoritesFiltered, selectedFilters, hasLocalFilter);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);
  useEffect(() => {
    if (show) {
      document.body.classList.add("modal-blur-overlay-active");
    } else {
      document.body.classList.remove("modal-blur-overlay-active");
    }
    return () => {
      document.body.classList.remove("modal-blur-overlay-active");
    };
  }, [show]);
  useEffect(() => {
    if (openSearch && inputRef.current) {
      inputRef.current.focus();
    }
  }, [openSearch]);
  const [filterOptions, setFilterOptions] = useState({
    home: {
      label: "Engagement",
      options: [
        { value: "0.1-1.0", label: "0.10% - 1.00%" },
        { value: "1.0-2.0", label: "1.00% - 2.00%" },
        { value: "2.0-3.0", label: "2.00% - 3.00%" },
        { value: "3.0-6.0", label: "3.00% - 6.00%" },
        { value: "6.0-9.0", label: "6.00% - 9.00%" },
      ],
    },
    menu1: {
      label: "Reach",
      options: [
        { value: "0 - 100k", label: "(0 - 100k)" },
        { value: "100k - 200k", label: "(100k - 200k)" },
        { value: "200k - 300k", label: "(200k - 300k)" },
        { value: "300k - 400k", label: "(300k - 400k)" },
        { value: "400k - 500k", label: "(400k - 500k)" },
        { value: "500k - 600k", label: "(500k - 600k)" },
        { value: "600k - 700k", label: "(600k - 700k)" },
        { value: "700k - 800k", label: "(700k - 800k)" },
        { value: "800k - 900k", label: "(800k - 900k)" },
        { value: "900k+", label: "900k+" },
      ],
    },
    menu2: {
      label: "Language",
      options: [
        { value: "english", label: "English" },
        { value: "Hindi", label: "Hindi" },
        { value: "Gujarati", label: "Gujarati" },
        { value: "Punjabi", label: "Punjabi" },
        { value: "Telugu", label: "Telugu" },
        { value: "Tamil", label: "Tamil" },
        { value: "Malayalam", label: "Malayalam" },
        { value: "Kannada", label: "Kannada" },
      ],
    },
    menu3: {
      label: "Followers",
      options: [
        { value: "1k-5k", label: "Nano Influencers (1K - 5K)" },
        { value: "5k-25k", label: "Micro Influencers (5K - 25K)" },
        { value: "25k-100k", label: "Mid Influencers (25K - 100K)" },
        { value: "100k-500k", label: "Macro Influencers (100K - 500K)" },
        { value: "500k+", label: "Mega Influencers (500K+)" },
      ],
    },
    menu4: {
      label: "Category",
      options: [], // This will be updated dynamically after API fetch
    },
    menu5: {
      label: "Age",
      options: [
        { value: "13-17", label: "13-17" },
        { value: "18-24", label: "18-24" },
        { value: "25-34", label: "25-34" },
        { value: "35-44", label: "35-44" },
        { value: "45-54", label: "45-54" },
        { value: "55-64", label: "55-64" },
        { value: "65+", label: "65+" },
      ],
    },
    menu6: {
      label: "City",
      options: [
        { value: "Mumbai", label: "Mumbai" },
        { value: "Delhi", label: "Delhi" },
        { value: "Bangalore", label: "Bangalore" },
        { value: "Chennai", label: "Chennai" },
        { value: "Kolkata", label: "Kolkata" },
        { value: "Jaipur", label: "Jaipur" },
        { value: "Hyderabad", label: "Hyderabad" },
        { value: "Other Cities", label: "Other Cities" },
      ],
    },
    menu7: {
      label: "Audience Gender",
      options: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" },
      ],
    },
  });
  const handleFilterChange = (category, value) => {
    setSelectedFilters((prevFilters) => {
      const newFilters = { ...prevFilters };
      if (!newFilters[category]) {
        newFilters[category] = [];
      }
      const currentValues = newFilters[category];
      const idx = currentValues.indexOf(value);
      if (idx > -1) {
        newFilters[category] = currentValues.filter((v) => v !== value);
        if (newFilters[category].length === 0) delete newFilters[category];
      } else {
        newFilters[category] = [...currentValues, value];
      }
      return newFilters;
    });
  };
  const resetFilters = () => {
    setSelectedFilters({}); // Clear all selected filters
    setSelectedTab(Object.keys(filterOptions)[0]); // Reset to first tab (optional)
    setIsClientPagination(false);
    fetchInfluencers(searchTerm, isFavoritesFiltered, {}, false);
    setCurrentPage(1);
  };
  const favoritesSort = () => {
    const newIsFavorites = !isFavoritesFiltered;
    fetchInfluencers(searchTerm, newIsFavorites, selectedFilters, false);
    setIsFavoritesFiltered(newIsFavorites);
  };
  const handleShowAllItems = () => {
    console.log("Button clicked!");
    setIsFavoritesFiltered(false);
    fetchInfluencers(searchTerm, false, selectedFilters, false);
  };
  const handleClearAll = () => {
    resetFilters();
  };
  const handleApply = () => {
    const localCategories = ["menu1", "menu2", "menu5", "menu6"];
    const serverCategories = ["home", "menu3", "menu4", "menu7"];
    const hasLocalFilter = localCategories.some(
      (cat) => selectedFilters[cat] && selectedFilters[cat].length > 0
    );
    const hasServerFilter = serverCategories.some(
      (cat) => selectedFilters[cat] && selectedFilters[cat].length > 0
    );
    setCurrentPage(1);
    setIsClientPagination(hasLocalFilter);
    fetchInfluencers(
      searchTerm,
      isFavoritesFiltered,
      selectedFilters,
      hasLocalFilter
    );
    setOpen(false); // Close sidebar on apply
  };
  // Client-side pagination and local filtering
  useEffect(() => {
    if (isClientPagination && allInfluencers.length > 0) {
      let filtered = applyLocalFilters(allInfluencers);
      const from = (currentPage - 1) * recordsPerPages;
      const paginated = filtered.slice(from, from + recordsPerPages);
      setInfluencers(paginated);
      setTotalCount(filtered.length);
    }
  }, [
    allInfluencers,
    currentPage,
    recordsPerPages,
    selectedFilters,
    isClientPagination,
  ]);
  // Server-side pagination useEffect
  useEffect(() => {
    if (!isClientPagination) {
      fetchInfluencers();
    }
  }, [currentPage, recordsPerPages]);
  return (
    <>
      <div style={{ fontFamily: "Poppins, san-serif !important" }}>
        {allowed !== null && (
          <Box
            sx={{
              bgcolor: " rgba(247, 215, 216, 0.5)",
              borderRadius: "8px",
              padding: "8px 24px",
              marginBottom: "10px",
              display: "flex",
            }}
          >
            <Typography color="#505050" fontFamily="Poppins,sans-serif">
              You've viewed
            </Typography>
            <Typography
              color="#505050"
              fontFamily="Poppins,sans-serif"
              sx={{ fontWeight: 700, paddingLeft: "5px" }}
            >
              {viewed}/{allowed} profiles
            </Typography>
            <Typography color="#505050" fontFamily="Poppins,sans-serif">
              . Upgrade to see more!
            </Typography>
            <Typography
              component="a"
              href="/subscription"
              fontFamily="Poppins,sans-serif"
              sx={{ paddingLeft: "5px", color: "#6B8E76", fontWeight: 700 }}
            >
              Upgrade
            </Typography>
          </Box>
        )}
        <div className="d-flex justify-content-between align-items-center">
          <div className="SearchFilterSection d-flex align-items-center justify-content-between w-100">
            <div className="creator-length" style={{ color: "#121212" }}>
              Find and Connect With Influencer
            </div>
            <div className="d-flex align-items-center ms-auto gap-2">
              {!(influencers.length === 0 && isFavoritesFiltered === true) && (
                <div className="d-flex align-items-center no-shadow">
                  <SearchBar
                    searchQuery={searchTerm}
                    setSearchQuery={(value) => setSearchTerm(value)}
                    autofocus
                    placeholder="Search Creators"
                  />
                </div>
              )}
              {/* Filters Button */}
              {!(influencers.length === 0 && isFavoritesFiltered === true) && (
                <div className="filter-icon-container">
                  <img
                    src={filter}
                    alt="Filter"
                    className="filter-icon"
                    onClick={() => setOpen(true)}
                  />
                </div>
              )}
              {open && (
                <div className="filter-overlay">
                  <div className="filter-sidebar">
                    <div className="filter-header d-flex justify-content-between align-items-center">
                      <h5>Filters</h5>
                      <button
                        onClick={() => setOpen(false)}
                        className="btn-close"
                      ></button>
                    </div>
                    <div className="FilterBox">
                      <div className="filter-tabs">
                        <div
                          className={`tab ${
                            activeFilterTab === "category" ? "active" : ""
                          }`}
                          onClick={() => setActiveFilterTab("category")}
                        >
                          By Category/ies
                        </div>
                        <div
                          className={`tab ${
                            activeFilterTab === "engagement" ? "active" : ""
                          }`}
                          onClick={() => setActiveFilterTab("engagement")}
                        >
                          By Engagement Rate
                        </div>
                        <div
                          className={`tab ${
                            activeFilterTab === "followers" ? "active" : ""
                          }`}
                          onClick={() => setActiveFilterTab("followers")}
                        >
                          By Followers
                        </div>
                        <div
                          className={`tab ${
                            activeFilterTab === "gender" ? "active" : ""
                          }`}
                          onClick={() => setActiveFilterTab("gender")}
                        >
                          By Audience Gender
                        </div>
                      </div>
                      {activeFilterTab === "category" && (
                        <div className="category-list">
                          {categories.map((cat) => (
                            <div
                              key={cat.id}
                              className="form-check"
                              style={{
                                padding: "0px",
                                paddingLeft: "20px",
                                paddingBottom: "10px",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`category-${cat.id}`}
                                checked={
                                  selectedFilters.menu4?.includes(cat.id) ||
                                  false
                                }
                                onChange={() =>
                                  handleFilterChange("menu4", cat.id)
                                }
                                style={{ padding: "0px" }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`category-${cat.id}`}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {cat.category}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                      {activeFilterTab === "engagement" && (
                        <div className="engagement-list">
                          {filterOptions.home.options.map((option) => (
                            <div
                              key={option.value}
                              className="form-check"
                              style={{
                                padding: "0px",
                                paddingLeft: "20px",
                                paddingBottom: "10px",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`engagement-${option.value}`}
                                checked={
                                  selectedFilters.home?.includes(option.value) ||
                                  false
                                }
                                onChange={() =>
                                  handleFilterChange("home", option.value)
                                }
                                style={{ padding: "0px" }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`engagement-${option.value}`}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                      {activeFilterTab === "followers" && (
                        <div className="followers-list">
                          {filterOptions.menu3.options.map((option) => (
                            <div
                              key={option.value}
                              className="form-check"
                              style={{
                                padding: "0px",
                                paddingLeft: "20px",
                                paddingBottom: "10px",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`followers-${option.value}`}
                                checked={
                                  selectedFilters.menu3?.includes(option.value) ||
                                  false
                                }
                                onChange={() =>
                                  handleFilterChange("menu3", option.value)
                                }
                                style={{ padding: "0px" }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`followers-${option.value}`}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                      {activeFilterTab === "gender" && (
                        <div className="gender-list">
                          {filterOptions.menu7.options.map((option) => (
                            <div
                              key={option.value}
                              className="form-check"
                              style={{
                                padding: "0px",
                                paddingLeft: "20px",
                                paddingBottom: "10px",
                              }}
                            >
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id={`gender-${option.value}`}
                                checked={
                                  selectedFilters.menu7?.includes(option.value) ||
                                  false
                                }
                                onChange={() =>
                                  handleFilterChange("menu7", option.value)
                                }
                                style={{ padding: "0px" }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`gender-${option.value}`}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {option.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <div className="filter-footer d-flex justify-content-between mt-3">
                      <button
                        className="btn btn-link text-muted"
                        onClick={handleClearAll}
                      >
                        Clear All
                      </button>
                      <button className="btn btn-success" onClick={handleApply}>
                        Apply
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <>
                <Button
                  variant="text"
                  onClick={handleOpenDialog}
                  sx={{
                    border: "1px solid #6B8E76 !important",
                    color: "#6B8E76 !important",
                    borderRadius: "8px",
                    padding: "8px 24px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: "14px !important",
                    backgroundColor: "transparent",
                    minWidth: "unset",
                    fontFamily: '"Poppins",sans-serif',
                    marginLeft: "10px !important",
                    boxShadow: "none !important",
                  }}
                >
                  Request Influencers
                </Button>
                <AddInfluencerDialog
                  open={openDialog}
                  handleClose={handleCloseDialog}
                />
              </>
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="">
            {isFavoritesFiltered === true ? (
              <></>
            ) : (
              <div className="InfluancerCardView Shorting influencer-list"></div>
            )}
            {grideView ? (
              <>
                <InfluencerGridList
                  influencers={influencers}
                  toggleFavorite={toggleFavorite} // Pass toggleFavorite function as a prop
                  isFavoritesFiltered={isFavoritesFiltered}
                />
              </>
            ) : (
              <div className="">
                {influencers?.length > 0 ? (
                  <>
                    <div className="InfluancerCardView Shorting influencer-list">
                      {influencers.length === 0 && isFavoritesFiltered ? (
                        <>
                          <div
                            className="min-h-screen flex items-center justify-center bg-gray-50"
                            style={{ marginTop: "95px" }}
                          >
                            <div className="text-center px-4 max-w-md mx-auto">
                              <div>
                                <img
                                  src={newNoFavorite}
                                  alt="No Campaigns"
                                  className="object-contain"
                                />
                              </div>
                              <h2 className="Title">
                                You haven’t added any favorites yet
                              </h2>
                              <p className="text-gray-blank-600 mb-8">
                                Start adding items you love to access them
                                quickly later.
                              </p>
                              <button
                                className="add-favorite"
                                type="button"
                                onClick={() => favoritesSort()}
                              >
                                Add to Favorite
                              </button>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="influencer-heading-card">
                          <div
                            className="InfluencerProfile-heading"
                            style={{ marginLeft: "-5px" }}
                          >
                            Creators
                          </div>
                          <div
                            className="InfluencerGenre-heading"
                            style={{
                              marginLeft: "-88px",
                              paddingLeft: "116px",
                              cursor: "pointer",
                            }}
                          >
                            Category{" "}
                          </div>
                          <div
                            className="engagement-heading"
                            onClick={() => handleSortEngagement()}
                            style={{ marginLeft: "46px", paddingLeft: "-10px" }}
                          >
                            ER %{" "}
                            <img
                              src={
                                sortDirectionEngagement === "asc"
                                  ? Sort
                                  : SortDown
                              }
                              className="img-fluid Sort"
                              alt="Sort Icon"
                            />
                          </div>
                          <div
                            className="InfluencerFollowes-heading"
                            onClick={handleSortFollowers}
                            style={{ marginLeft: "-91px", paddingLeft: "54px" }}
                          >
                            Followers{" "}
                            <img
                              src={
                                sortDirectionFollowers === "asc"
                                  ? Sort
                                  : SortDown
                              }
                              className="img-fluid Sort"
                              alt="Sort Icon"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div className="InfluancerCardView">
                  <div className="influencer-list">
                    {influencers.length === 0 && searchTerm ? (
                      isLoding ? (
                        <div
                          className="min-h-screen flex items-center justify-center bg-gray-50"
                          style={{ marginTop: "95px" }}
                        >
                          <div className="text-center px-4 max-w-md mx-auto">
                            <h2 className="Title">Loading....</h2>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="min-h-screen flex items-center justify-center bg-gray-50"
                          style={{ marginTop: "95px" }}
                        >
                          <div className="text-center px-4 max-w-md mx-auto">
                            <div>
                              <img
                                src={searchResult}
                                alt="No Campaigns"
                                className="object-contain"
                              />
                            </div>
                            <h2 className="Title">No Result Found</h2>
                            <p className="text-gray-blank-600 mb-8">
                              Try Adjusting your Search
                              <br />
                              to find what you are looking for
                            </p>
                          </div>
                        </div>
                      )
                    ) : (
                      influencers.map((influencer) => (
                        <div
                          key={influencer.user_id}
                          className="influencer-card"
                          cursor="pointer"
                          onClick={() =>
                            navigate(`/influencer/${influencer.user_id}`)
                          }
                        >
                          <div className="InfluencerProfile">
                            <img
                              src={
                                influencer?.profile
                                  ? influencer.profile
                                  : influencers?.ProfileImg || ProfileImg
                              }
                              className="img-fluid"
                              alt={
                                [influencer?.first_name, influencer?.last_name]
                                  .filter(Boolean)
                                  .join(" ") || "Unknown Influencer"
                              }
                              style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                border: "2px solid #ccc",
                              }}
                            />
                            <h4>
                              {[influencer?.first_name, influencer?.last_name]
                                .filter(Boolean)
                                .join(" ") || "Unknown Influencer"}
                            </h4>
                          </div>
                          {/* Category */}
                          <div
                            className="InfluencerGenre"
                            style={{
                              marginLeft: "-21px",
                              paddingRight: "38px",
                            }}
                          >
                            {influencer?.category?.length ? (
                              (() => {
                                const category = influencer.category;
                                return (
                                  <Box
                                    display={"flex"}
                                    gap={1}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                  >
                                    {category?.[0]?.name}
                                    {category.length > 1 && (
                                      <Tooltip
                                        title={
                                          <Box
                                            display="flex"
                                            flexDirection="column"
                                          >
                                            {category
                                              .slice(1)
                                              .map((i, idx) =>
                                                i?.name ? (
                                                  <span key={idx}>
                                                    {i.name}
                                                  </span>
                                                ) : null
                                              )}
                                          </Box>
                                        }
                                        placement="bottom"
                                        sx={{
                                          "& .MuiTooltip-tooltip": {
                                            fontFamily:
                                              "Poppins, sans-serif !important",
                                            fontSize: "14px",
                                            letterSpacing: "0.5px",
                                          },
                                        }}
                                      >
                                        <Chip
                                          sx={{
                                            backgroundColor: "#ccc",
                                            color: "#333",
                                            fontFamily: "Poppins, sans-serif",
                                            cursor: "pointer",
                                          }}
                                          label={`+ ${category.length - 1}`}
                                        />
                                      </Tooltip>
                                    )}
                                  </Box>
                                );
                              })()
                            ) : (
                              <>N/A</>
                            )}
                          </div>
                          <div
                            className="engagement"
                            style={{
                              marginLeft: "-36px",
                              paddingRight: "240px",
                            }}
                          >
                            {influencer?.engagement === 0 ? (
                              0
                            ) : influencer?.engagement ? (
                              <span>
                                {formatNumberWithSuffix(influencer?.engagement)}
                              </span>
                            ) : (
                              "N/A"
                            )}
                          </div>
                          <div
                            className="InfluencerFollowes"
                            style={{
                              marginLeft: "-276px",
                              paddingLeft: "138px",
                            }}
                          >
                            {formatNumberWithSuffix(influencer?.followers)}
                          </div>
                          <div className="Likes">
                            <Box
                              width={"35px"}
                              height={"35px"}
                              sx={{
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleFavorite(influencer.user_id);
                              }}
                            >
                              {influencer.flag_favorite ? (
                                <IoIosHeart color="#6b8e76" size={35} />
                              ) : (
                                <IoIosHeartEmpty color="#6b8e76" size={35} />
                              )}
                            </Box>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            )}
            {influencers.length > 0 ? (
              <ThemeProvider theme={theme}>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Pagination
                    count={Math.ceil(totalCount / recordsPerPages)}
                    showFirstButton
                    showLastButton
                    page={currentPage}
                    onChange={(_, page) => {
                      setCurrentPage(page);
                    }}
                    sx={{
                      "& button": {
                        border: "none !important",
                      },
                    }}
                    shape="circular"
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{
                          first: MdKeyboardDoubleArrowLeft,
                          last: MdKeyboardDoubleArrowRight,
                        }}
                        {...item}
                      />
                    )}
                  />
                </Box>
              </ThemeProvider>
            ) : (
              <></>
            )}
          </div>
        </div>
        {isFilterPopupOpen && (
          <div className="filter-popup">
            <div className="filter-popup-content">
              <div className="FilterHeader">
                <li className="active">
                  <h6>Filter</h6>
                </li>
                <div className="clear-btn" onClick={() => resetFilters()}>
                  <span>Clear all</span>
                </div>
                <i
                  className="fa fa-times"
                  onClick={() => setIsFilterPopupOpen(false)}
                ></i>
              </div>
              <div className="Filters">
                <ul className="nav nav-pills">
                  {Object.keys(filterOptions).map((key) => (
                    <li
                      key={key}
                      className={selectedTab === key ? "active" : ""}
                      onClick={() => handleTabChange(key)} // Ensure the function is correctly triggered
                    >
                      {filterOptions[key].label}
                    </li>
                  ))}
                </ul>
                <div className="filter-options">
                  {selectedTab && (
                    <>
                      {filterOptions[selectedTab].options.map((option) => (
                        <div className="form-check" key={option.value}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`${selectedTab}-${option.value}`}
                            checked={
                              selectedFilters[selectedTab]?.includes(option.value) ||
                              false
                            }
                            onChange={() =>
                              handleFilterChange(selectedTab, option.value)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${selectedTab}-${option.value}`}
                          >
                            {option.label}
                          </label>
                        </div>
                      ))}
                    </>
                  )}
                  <div className="BtnsGrp">
                    <span>{influencers?.length} Influencers</span>
                    <button
                      type="button"
                      className="btn btn-apply"
                      onClick={handleApply}
                      style={{ backgroundColor: "#6b8e76", color: "white" }}
                    >
                      Apply Filters
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
export default BrandHome;